import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Http, ResponseContentType } from '@angular/http';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { API_VERSION, BASE_URL } from '../../../environments/environment';
import { AccountApi } from '../../shared/sdk';
import { NotificationsService } from 'angular2-notifications';

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.scss']
})
export class PasswordResetComponent implements OnInit {

  public passwordResetData: any;
  public userInfo: any;
  public passwordResetForm: FormGroup;
  public currentPasswordStatus: boolean = false;
  public isCurrentPasswordVerified: boolean = false;
  public isPasswordExpired: boolean = false;
  public showEmailNotVerifiedMsg: boolean = false;

  error_messages = {
    'password': [
      { type: 'required', message: 'Password is required.' },
      { type: 'minlength', message: 'Minimum password length is 8 character.' },
      { type: 'maxlength', message: 'Maximum password length is 16 character.' }
    ]
  }

  constructor(public http: Http, public router: Router, public location: Location,
    public formBuilder: FormBuilder, public accountApi: AccountApi,
    public activatedRoute: ActivatedRoute, public _NotificationService: NotificationsService) { }

  ngOnInit() {
    if (this.activatedRoute.snapshot.params && this.activatedRoute.snapshot.params.isPasswordExpired) {
      this.userInfo = this.activatedRoute.snapshot.params.userinfo;
      this.isPasswordExpired = this.activatedRoute.snapshot.params.isPasswordExpired
    } else {
      this.isPasswordExpired = false;
    }
    if (this.router.url.split('userinfo=')[1]) {
      this.userInfo = this.router.url.split('userinfo=')[1];
    } else {
      if (window.location.href.includes("userinfo=")) {
        this.userInfo = window.location.href.split('userinfo=')[1];
      }
    }
    if (this.isPasswordExpired || this.activatedRoute.snapshot.params.isPasswordExpired) {
      this.passwordResetForm = this.formBuilder.group({
        currentpassword: new FormControl('', Validators.compose([
          // Validators.required
        ])),
        password: new FormControl('', Validators.compose([
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(16)
        ])),
        confirmpassword: new FormControl('', Validators.compose([
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(16)
        ]))
      });
    } else {
      this.passwordResetForm = this.formBuilder.group({
        password: new FormControl('', Validators.compose([
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(16)
        ])),
        confirmpassword: new FormControl('', Validators.compose([
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(16)
        ])),
      });
    }
    console.log(this.userInfo);
  }

  onSubmit() {
    if ((!this.currentPasswordStatus && this.passwordResetForm.valid) || (this.isPasswordExpired && this.passwordResetForm.valid)) {
      this.http.post(BASE_URL + '/' + API_VERSION + '/createorchangepassword',
        { encrypteduser: this.userInfo, password: this.passwordResetForm.value }).map(res => res.json())
        .subscribe((data: any) => {
          console.log('Password reset successs data', data);
          if (data && !data.emailVerified) {
            this.showEmailNotVerifiedMsg = true;
          } else {
            this.accountApi.logout();
            this.showEmailNotVerifiedMsg = false;
            this.passwordResetForm.reset();
            this.router.navigate(['/success'], { replaceUrl: true });
            this._NotificationService.success('Message', 'Password has been changed successfully. Please Login.');
          }
        }, error => {
          console.log('Error while updating password', JSON.stringify(error));
          error = JSON.parse(error);
          let msg = 'Error, Please try again later.';
          if (error && (error._body && error._body.message) || (error.message)) msg = error._body.message || error.message
          this._NotificationService.info('Message', msg);
        });
    } else {
      console.log('Not Valid form.');
    }
  }

  verifyExistingPassword() {
    let userinfo = { encrypteduser: this.userInfo, password: this.passwordResetForm.value.currentpassword };
    console.log('userinfo', userinfo);
    console.log(BASE_URL + '/' + API_VERSION + '/verifycurrentpassword');
    if (this.passwordResetForm.value.currentpassword) {
      try {
        this.http.post(BASE_URL + '/' + API_VERSION + '/verifycurrentpassword', userinfo)
          .map(res => res.json())
          .subscribe(data => {
            console.log('Password reset successs data', data);
            this.isCurrentPasswordVerified = true;
            this.currentPasswordStatus = data.status;
          }, error => {
            this.isCurrentPasswordVerified = true;
            console.log('Error while updating password', error);
            this._NotificationService.success('Message', 'Error while verifying current password.')
          });
      } catch (error) {
        console.log('Error', error);
      }
    }
  }

  validatePassword() {
    return this.passwordResetForm.value.password === this.passwordResetForm.value.confirmpassword ? false : true;
  }

}




// WEBPACK FOOTER //
// ./src/app/app-modules/password-reset/password-reset.component.ts